import { Box, Skeleton } from "@mui/material";

const ScheduledSkeleton = () => {
  return (
    <Box sx={{ px: 3 }}>
      <Skeleton height="50px" width="50%" />
      <Skeleton animation="wave" width="100%" height="250px" sx={{ mt: -4 }} />
      <Skeleton animation="wave" width="100%" height="250px" sx={{ mt: -10 }} />
      <Skeleton animation="wave" width="100%" height="250px" sx={{ mt: -10 }} />
      <Skeleton animation="wave" width="100%" height="250px" sx={{ mt: -10 }} />
    </Box>
  );
};

export default ScheduledSkeleton;
